module.exports = __webpack_public_path__ + "static/media/EnCORE_consent_FR_p5.8a8d8c94.jpg";